export type AccessRoleRelation = {
  name?: string | null;
  is_super_admin?: boolean | null;
};

export type AccessRoleRow = {
  org_id?: string | null;
  roles?: AccessRoleRelation | AccessRoleRelation[] | null;
};

export type AccessRoleSummary = {
  isSuperAdmin: boolean;
  isAdmin: boolean;
  isCampaignManager: boolean;
  isBud: boolean;
  isSupervisor: boolean;
  isLineManager: boolean;
  isFinanceViewer: boolean;
  isFinance: boolean;
  isManager: boolean;
};

export const emptyAccessRoleSummary: AccessRoleSummary = {
  isSuperAdmin: false,
  isAdmin: false,
  isCampaignManager: false,
  isBud: false,
  isSupervisor: false,
  isLineManager: false,
  isFinanceViewer: false,
  isFinance: false,
  isManager: false,
};

const getRoleRelations = (roles: AccessRoleRow['roles']) => {
  if (!roles) return [];
  return Array.isArray(roles) ? roles : [roles];
};

const normalizeAccessRoleName = (name?: string | null) =>
  name?.trim().toLowerCase().replace(/\s+/g, ' ') ?? '';

export const summarizeAccessRoles = (rows: AccessRoleRow[] = []): AccessRoleSummary => {
  const summary = { ...emptyAccessRoleSummary };

  rows.forEach((row) => {
    getRoleRelations(row.roles).forEach((role) => {
      const roleName = normalizeAccessRoleName(role.name);

      if (role.is_super_admin === true) {
        summary.isSuperAdmin = true;
      }

      if (roleName === 'admin') {
        summary.isAdmin = true;
      }

      if (roleName === 'campaign manager') {
        summary.isCampaignManager = true;
      }

      if (
        roleName === 'bud' ||
        roleName === 'business unit director' ||
        roleName === 'business unit director (bud)'
      ) {
        summary.isBud = true;
      }

      if (roleName === 'supervisor' || roleName === 'line manager') {
        summary.isSupervisor = true;
      }

      if (roleName === 'line manager') {
        summary.isLineManager = true;
      }

      if (roleName === 'finance') summary.isFinance = true;

      if (roleName === 'finance viewer' || roleName === 'finance') {
        summary.isFinanceViewer = true;
      }
    });
  });

  summary.isManager =
    summary.isSuperAdmin ||
    summary.isAdmin ||
    summary.isCampaignManager ||
    summary.isBud ||
    summary.isSupervisor ||
    summary.isFinanceViewer;

  return summary;
};

export const hasManagerAccessRole = (row: AccessRoleRow) => summarizeAccessRoles([row]).isManager;
